import axios from "axios";

// `REACT_APP_BACKEND_URL` is baked at build-time and points at the original
// Emergent host. When the app is later served from a custom domain
// (e.g. app.nlpmagick.nl), calling that baked host would be cross-origin and
// CORS-rejected. Emergent's ingress routes `/api/*` on the *current* host to
// the same backend pod, so the safest call is **same-origin `/api`** whenever
// the page's origin differs from the baked one.
function resolveApiBase() {
  const baked = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return `${baked}/api`;
  try {
    const here = window.location.origin;
    if (!baked) return `${here}/api`;
    const bakedOrigin = new URL(baked).origin;
    return bakedOrigin === here ? `${baked}/api` : `${here}/api`;
  } catch {
    return `${baked}/api`;
  }
}

export const API = resolveApiBase();

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("magick_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
